import { useMemo } from 'react';

import { useUserSetting } from '../../../../../hooks/use-user-setting';
import { UserSettings } from '../../../../../enums/user-settings/user-settings';
import { CardType } from '../types';
import { DEFAULT_CARD_TYPES } from '../constants/card-registry';

export const useSelectedCardTypes = (): CardType[] => {
  const settingValue = useUserSetting(UserSettings.operationsSnapshotSelectedCards.settingName);

  return useMemo(() => {
    if (!settingValue) {
      return DEFAULT_CARD_TYPES;
    }

    try {
      const parsed = JSON.parse(settingValue);
      if (Array.isArray(parsed) && parsed.length === 3 && parsed.every((type) => Object.values(CardType).includes(type))) {
        return parsed;
      }
    } catch {
      // Invalid JSON, fall back to defaults
    }

    return DEFAULT_CARD_TYPES;
  }, [settingValue]);
};
